import api from "@/router/api";

export default {
  async gerarPinCode(emailOuCpf) {
    const response = await api.post("/controle-acesso/generate", {
      emailOrCpf: emailOuCpf,
    });
    return response.data || response;
  },

  async validarPinCode(data) {
    const response = await api.post("/controle-acesso/valid", data);
    return response.status;
  },

  async recuperarSenha(email) {
    const response = await api.post("/recuperacao-senha", {
      email,
    });
    return response.data || response;
  },

  async redefinirSenha(payload) {
    const { token, senha } = payload;
    const response = await api.post(`/recuperacao-senha/${token}`, {
      novaSenha: senha,
    });
    return response.data || response;
  },
};
